import { render, staticRenderFns } from "./DematSru.vue?vue&type=template&id=bbf62dbc&"
import script from "./DematSru.vue?vue&type=script&lang=js&"
export * from "./DematSru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports